import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const FacebookIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      fill="currentcolor"
      d="M30 16.086C30 8.306 23.732 2 16 2S2 8.306 2 16.086C2 23.116 7.12 28.943 13.813 30v-9.843h-3.555v-4.071h3.555v-3.104c0-3.53 2.09-5.48 5.288-5.48 1.531 0 3.133.275 3.133.275v3.467H20.47c-1.739 0-2.282 1.085-2.282 2.2v2.642h3.883l-.62 4.071h-3.262V30C24.88 28.943 30 23.116 30 16.086"
    />
  </IconV2>
);

export default FacebookIcon;
